import PropTypes from "prop-types";
import { useMemo } from "react";
import { withTranslation } from "react-i18next";
import { Card, CardBody, Col, Row } from "reactstrap";

const UpskillingPageHero = ({ t }) => {
  const introSteps = useMemo(
    () => [
      t("upskillingHeroStep1", "Take a course."),
      t("upskillingHeroStep2", "Gain a qualification."),
      t("upskillingHeroStep3", "Unlock more work opportunities."),
    ],
    [t]
  );

  const benefits = useMemo(
    () => [
      t("upskillingHeroBenefit1", "Access more roles"),
      t("upskillingHeroBenefit2", "Increase earning potential"),
      t("upskillingHeroBenefit3", "Improve employability"),
      t("upskillingHeroBenefit4", "Gain recognised qualifications"),
      t("upskillingHeroBenefit5", "Stand out to clients"),
    ],
    [t]
  );

  return (
    <Card className="upskilling-page-hero mb-4 border-0">
      <CardBody className="p-4 p-lg-5">
        <Row className="g-4 g-lg-5 align-items-start">
          <Col lg={7}>
            <div className="upskilling-page-hero__eyebrow mb-2">
              {t("workerMenuUpskilling", "Upskilling")}
            </div>
            <h2 className="upskilling-page-hero__title mb-4">
              {t("upskillingHeroTitle", "Access more opportunities")}
            </h2>

            <ul className="upskilling-page-hero__steps list-unstyled mb-4">
              {introSteps.map((step) => (
                <li key={step}>
                  <span className="upskilling-page-hero__step-icon" aria-hidden="true">
                    <i className="bx bx-right-arrow-alt" />
                  </span>
                  <span>{step}</span>
                </li>
              ))}
            </ul>

            <p className="upskilling-page-hero__pacing mb-0">
              {t(
                "upskillingHeroPacing",
                "Learn at your own pace and fit training around your existing work commitments."
              )}
            </p>
          </Col>

          <Col lg={5}>
            <div className="upskilling-page-hero__benefits">
              <h3 className="upskilling-page-hero__benefits-title">
                {t("upskillingHeroWhyTitle", "Why upskill?")}
              </h3>
              <ul className="upskilling-page-hero__benefits-list list-unstyled mb-0">
                {benefits.map((benefit) => (
                  <li key={benefit}>
                    <span className="upskilling-page-hero__check" aria-hidden="true">
                      <i className="bx bx-check" />
                    </span>
                    <span>{benefit}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

UpskillingPageHero.propTypes = {
  t: PropTypes.func,
};

export default withTranslation()(UpskillingPageHero);
